import { useEffect } from "react"

export default function usePlotlyResizeObserver({
  containerRef,
  isInitializedRef,
  legendMinWidth,
  onResize,
  onLegendVisibilityChange,
}) {
  useEffect(() => {
    const container = containerRef.current
    if (!container || typeof ResizeObserver === "undefined") {
      return
    }

    const ro = new ResizeObserver(() => {
      const current = containerRef.current
      if (!current || !isInitializedRef.current || !current.isConnected) {
        return
      }
      try {
        onResize(current)

        const showlegend = current.offsetWidth > legendMinWidth
        if (current.layout?.showlegend !== showlegend) {
          onLegendVisibilityChange(current, showlegend)
        }
      } catch {
        // no-op on error
      }
    })
    ro.observe(container)
    return () => ro.disconnect()
  }, [containerRef, isInitializedRef, legendMinWidth, onResize, onLegendVisibilityChange])
}
